<template>
	<div class="card">
		<ul class="items">
			<li
				class="item"
				v-for="item in cardList"
				:key="item.id"
				@click="handleNavigatorLink(item.params)"
				:class="{ link: item.params }"
			>
				<img class="icon" :src="require(`@/assets/imgs/icon/${item.icon}.png`)" />
				<p class="title">{{ item.name }}</p>
				<div class="bold">
					{{ item.data || 0 }}
					<span class="unit">台</span>
				</div>
			</li>
		</ul>
	</div>
</template>

<script>
import { deviceDetailPermissions } from '@/config/const'
import { apiStatisticsCount } from '@/apis/home.api'

export default {
	name: 'DeviceStatis',
	data() {
		return {
			cardList: [
				{
					id: 1,
					name: '物联网表统计',
					key: 'deviceCount',
					icon: 'home-device-total',
					params: {
						deviceTypeClassify: '1',
						deviceStatus: '1',
						pageName: 'account',
						permission: deviceDetailPermissions,
					},
				},
				{
					id: 2,
					name: '离线设备',
					key: 'offlineDeviceCount',
					icon: 'home-online-device',
					params: {
						firstCategory: '0401',
						exceptionType: '1',
						update: true,
						pageName: 'abnormalRecords',
						permission: 'monitor:run:exception:select',
					},
				},
				{
					id: 3,
					name: '告警设备',
					key: 'alarmDeviceCount',
					icon: 'home-alarm',
					params: {
						firstCategory: '0401',
						update: true,
						pageName: 'alarmDevice',
						permission: 'monitor:run:alarm-device:select',
					},
				},
				{
					id: 4,
					name: '阀门强关设备',
					key: 'closeValveDeviceCount',
					icon: 'home-valve',
					params: {
						valveStatus: '0',
						deviceStatus: '1',
						update: true,
						pageName: 'closeValveDevice',
						permission: 'monitor:run:close-valve-device',
					},
				},
				{
					id: 5,
					name: '阀门普关设备',
					key: 'generalCloseValveDeviceCount',
					icon: 'home-valve',
					params: {
						valveStatus: '6',
						deviceStatus: '1',
						update: true,
						pageName: 'closeValveDevice',
						permission: 'monitor:run:close-valve-device',
					},
				},
				{
					id: 6,
					name: '开阀设备',
					key: 'openValveDeviceCount',
					icon: 'home-valve',
				},
			],
		}
	},
	methods: {
		getStatisCount() {
			apiStatisticsCount()
				.then(res => {
					this.cardList = this.cardList.map(item => {
						return {
							...item,
							data: res[item.key],
						}
					})
				})
				.catch(err => {
					console.error(err)
				})
		},

		handleNavigatorLink(params) {
			if (!params) return
			const { pageName, permission, ...args } = params
			if (permission && !this.$has(permission)) {
				return this.$message.error('您没有操作权限！')
			}
			this.$router.push({
				name: pageName,
				params: args,
			})
		},
	},

	activated() {
		this.getStatisCount()
	},
}
</script>
<style scoped lang="scss">
.card {
	height: 268px;
	display: flex;
}
.items {
	flex: 1;
	display: flex;
	justify-content: space-between;
	flex-wrap: wrap;
	.item {
		width: 31%;
		height: 100px;
		background: linear-gradient(225deg, #a7a6ff 0%, #a6beff 100%);
		border-radius: 8px;
		padding: 12px;
		position: relative;
		&.link {
			cursor: pointer;
		}
		&:nth-of-type(n + 4) {
			margin-top: 20px;
		}
		.icon {
			width: 28px;
			height: 28px;
		}
		.title {
			margin-top: 8px;
			font-size: 13px;
			color: #fff;
			white-space: nowrap;
		}
		.bold {
			margin-top: 4px;
			color: #fff;
			.unit {
				font-size: 14px;
				font-weight: normal;
			}
		}
		@media (max-width: 1680px) {
			.icon {
				width: 28px;
				height: 28px;
			}
			.title {
				margin-top: 8px;
			}
			.bold {
				margin-top: 8px;
				position: initial;
			}
		}
	}
}
</style>
